<template>
  <v-container>
    <div class="report-view report-summary-information report-age-composition">
      <div class="report-head">
        <div class="report-num">
          <p>Форма № учет — 6А</p>
        </div>
        <h4 class="text-center">Сведения</h4>
        <h5 class="text-center">по половозрастному составу диких копытных животных <br>в охотугодьях (участках)
          на {{ year }} года
          <label v-if="oopt"><u>{{ oopt }}</u>
            <span class="sm-hint">наименование охотпользователя</span>
          </label>
        </h5>
      </div>
      <!-- report-body -->
      <div class="report-body">
        <div class="table-overflow">
          <table class="table-full">
            <tbody>
            <tr>
              <td class="text-center" colspan="2"><strong>Трофейный вид</strong></td>
              <td class="text-center"><strong>Количество</strong></td>
            </tr>
              <template v-if="reportData.data.faunaResult" v-for="(fauna, i) in reportData.data.faunaResult">
                <tr>
                  <td class="td-num" rowspan="5">{{ i+1 }}</td>
                  <td class="text-center"><strong>{{ fauna.faunaName }}</strong></td>
                    <td class="text-center"><strong>{{ fauna.totalSum }}</strong></td>
                </tr>
                <tr>
                  <td>В том числе: 1. самцы</td>
                  <td class="text-center">{{ fauna.malesSum }}</td>
                </tr>
                <tr>
                  <td>2. из них старше 8 лет</td>
                  <td class="text-center">{{ fauna.malesFrom8AndHigherSum }}</td>
                </tr>
                <tr>
                  <td>3. самки</td>
                  <td class="text-center">{{ fauna.femalesSum }}</td>
                </tr>
                <tr>
                  <td>4. молодняк (сеголетки)</td>
                  <td class="text-center">{{ fauna.youngSum }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      <div class="report-footer">
        <p>М.П.</p>
        <div class="report-footer-item">
          <div class="flexbox">
            <div class="mr-6">
              <span>________________________________________</span>
              <div>Ф.И.О. должность охотпользователя</div>
            </div>
            <div class="mr-6">
              <span>__________</span>
              <div>подпись</div>
            </div>
            <div class="mr-6">
              <span>"____"____________20__г</span>
              <div class="text-center">дата</div>
            </div>
          </div>
        </div>
        <div class="report-footer-item">
          <div class="flexbox">
            <div class="mr-6">
              <span>________________________________________</span>
              <div>Присутствовал: Ф.И.О. должность <br> работника Департамента охоты</div>
            </div>
            <div class="mr-6">
              <span>__________</span>
              <div>подпись</div>
            </div>
            <div class="mr-6">
              <span>"____"____________20__г</span>
              <div class="text-center">дата</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  props: {
    reportData: Object,
    year: String,
    oopt: String
  }
}
</script>

<style scoped>

</style>
